<template>
  <div id="inteergralOrder">
    <div class="rightHead">
      <div
        style="margin:0 0 0 30px;font-size:15px;padding-top:16px;color:#707070;"
        v-if="$route.meta.titleShow"
      >
        {{ $route.name }}
      </div>
    </div>
    <div class="invoicingHead" style="height: 40px">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>积分订单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="searchGroup">
      <div class="row">
        <span class="orderNo">订单号</span>
        <el-input
          placeholder="请输入订单号"
          v-model="orderNo"
          style="width:220px;margin-right:20px;"
          @blur="orderNoNumBlur"
        ></el-input>
        <span class="orderNo">兑换号</span>
        <el-input
          placeholder="请输入兑换号"
          v-model="redeemCode"
          style="width:220px;margin-right:20px;"
          @blur="redeemCodeNumBlur"
        ></el-input>
        <span class="orderNo">兑换时间</span>
        <el-date-picker
          v-model="dateTime"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="dateChange"
        ></el-date-picker>
        <el-select
          v-model="orderStatus"
          placeholder="请选择"
          @change="orderStatusChange"
          style="padding: 0 20px;bor-sizing:border-box;"
        >
          <el-option
            v-for="item in orderStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
      <div class="table-content">
        <el-table
          :data="tableData"
          style="width: 100%"
          v-loading="loading"
          element-loading-background="rgba(0, 0, 0, 0.3)"
          element-loading-text="数据正在加载中"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column align="center" prop="goodsName" label="商品名称">
            <template slot-scope="scope">
              <div class="flex-row-start">
                <div>
                  <img
                    :src="scope.row.goodsImage"
                    style="width:50px;height:50px;padding:20px 0;"
                  />
                </div>
                <div class="goodsInfo">
                  <div>商品名称：{{ scope.row.goodsName }}</div>
                  <div>
                    兑换数量：{{ scope.row.buyCount }} {{ scope.row.unit }}
                  </div>
                  <div>所需积分：{{ scope.row.retailScore }}分</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="orderNo" label="订单号" />
          <el-table-column align="center" prop="createTime" label="兑换时间" />
          <el-table-column align="center" prop="redeemCode" label="兑换码" />
          <el-table-column align="center" prop="orderStatus" label="兑换状态">
            <template slot-scope="scope">
              <div v-if="scope.row.orderStatus == 1" style="color:green">
                待兑换
              </div>
              <div v-if="scope.row.orderStatus == 3">完成兑换</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                @click="finishMallOrder(scope.row)"
                v-if="scope.row.orderStatus == 1"
                >完成</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div
          v-if="tableData.length > 0"
          class="block"
          style="float:right;margin-top:10px;"
        >
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNo"
            :page-size="queryInfo.row"
            layout="total, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  officialMallOrderList,
  officialMallOrderListTotalNum,
  finishMallOrder
} from "../api/index";
export default {
  data() {
    return {
      tableData: [],
      loading: false,
      queryInfo: {
        pageNo: 1,
        row: 10
      },
      total: 0,
      status: "",
      userList: {},
      shopInformation: {},
      orderNo: "",
      redeemCode: "",
      dateTime: "",
      startDate: "",
      endDate: "",
      orderStatus: "",
      orderStatusList: [
        { value: "", label: "兑换状态" },
        { value: "1", label: "待兑换" },
        { value: "3", label: "完成兑换" }
      ],
      loading: false,
      btnDisabled: true
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    this.userList = userList;
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.shopInformation = shopInformation;
    this.getOfficialMallOrderList();
  },
  methods: {
    getOfficialMallOrderList(
      orderNo,
      redeemCode,
      startDate,
      endDate,
      orderStatus
    ) {
      this.loading = true;
      officialMallOrderList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        shopId: this.shopInformation.shopId,
        pageNo: this.queryInfo.pageNo,
        pageSize: this.queryInfo.row,
        orderNo: orderNo,
        redeemCode: redeemCode,
        startDate: startDate,
        endDate: endDate,
        orderStatus: orderStatus
      }).then(res => {
        this.loading = false;
        if (res.code == 1) {
          var list = [];
          for (var i in res.data) {
            res.data[i].products.forEach(item => {
              list.push({
                goodsImage: item.goodsImage,
                goodsName: item.goodsName,
                retailScore: item.retailScore,
                buyCount: item.buyCount,
                orderNo: res.data[i].orderNo,
                createTime: res.data[i].createTime,
                redeemCode: res.data[i].redeemCode,
                orderStatus: res.data[i].orderStatus,
                unit: item.unit,
                officialMallOrderId: item.officialMallOrderId
              });
            });
          }
          this.tableData = list;
          officialMallOrderListTotalNum({
            sessionId: this.userList.sessionId,
            userId: this.userList.id,
            shopId: this.shopInformation.shopId,
            pageNo: this.queryInfo.pageNo,
            pageSize: this.queryInfo.row,
            orderNo: orderNo,
            redeemCode: redeemCode,
            startDate: startDate,
            endDate: endDate,
            orderStatus: orderStatus
          }).then(res => {
            if (res.code == 1) {
              this.total = res.data.totalNum;
            } else if (res.code == -1) {
              this.tableData = [];
            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          });
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      if (this.status == 1) {
        this.getOfficialMallOrderList(
          this.orderNo,
          this.redeemCode,
          this.startDate,
          this.endDate,
          this.orderStatus
        );
      } else {
        this.getOfficialMallOrderList();
      }
    },
    search() {
      this.status = 1;
      this.queryInfo.pageNo = 1;
      this.getOfficialMallOrderList(
        this.orderNo,
        this.redeemCode,
        this.startDate,
        this.endDate,
        this.orderStatus
      );
    },
    orderNoNumBlur() {
      if (!this.orderNo) {
        this.getOfficialMallOrderList(
          "",
          this.redeemCode,
          this.startDate,
          this.endDate,
          this.orderStatus
        );
      }
    },
    redeemCodeNumBlur() {
      if (!this.redeemCode) {
        this.getOfficialMallOrderList(
          this.orderNo,
          "",
          this.startDate,
          this.endDate,
          this.orderStatus
        );
      }
    },
    dateChange(date) {
      if (!date) {
        this.getOfficialMallOrderList(
          this.orderNo,
          this.redeemCode,
          "",
          "",
          this.orderStatus
        );
        return;
      }
      this.startDate = date[0];
      this.endDate = date[1];
    },
    orderStatusChange(val) {
      this.getOfficialMallOrderList(
        this.orderNo,
        this.redeemCode,
        this.startDate,
        this.endDate,
        val
      );
    },
    finishMallOrder(row) {
      finishMallOrder({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        officialMallOrderId: row.officialMallOrderId
      }).then(res => {
        if (res.code == 1) {
          this.getOfficialMallOrderList();
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.flex-row-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.goodsInfo {
  text-align: left;
  padding-left: 20px;
  box-sizing: border-box;
  line-height: 35px;
}
#inteergralOrder {
  width: calc(100vw - 217px);
  height: calc(100vh);
  margin-left: 200px;
  min-width: 1340px;
  .searchGroup {
    width: 100%;
    padding-top: 120px;
    padding-left: 20px;
    box-sizing: border-box;
    .row {
      .orderNo {
        padding: 8px 10px 0 0;
      }
    }
    .table-content {
      width: calc(100vw - 280px);
      padding-top: 40px;
      box-sizing: border-box;
    }
  }
}
::v-deep .el-range-editor.el-input__inner {
  height: 40px;
  line-height: 40px;
}
::v-deep .el-table th {
  background: #f8f8f8;
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/page/intergralOrder.vue